import {
  BarChart3,
  Bell,
  Bot,
  Building2,
  CarFront,
  ChartColumn,
  ClipboardList,
  Compass,
  Contact,
  Globe,
  LayoutDashboard,
  LifeBuoy,
  type LucideIcon,
  Megaphone,
  MessagesSquare,
  Phone,
  Plug,
  Radio,
  Receipt,
  Settings,
  ShieldCheck,
  Users,
  Wallet,
} from 'lucide-react';

/**
 * A glyph per handbook module, so a stack of source cards is scannable by shape
 * before it is read — "the Finance one" is how an operator actually remembers
 * which article answered them.
 *
 * Keyed on the module names the handbook frontmatter actually declares
 * (console/content/**). An unknown module falls back to the book, which is why
 * adding a module to the handbook never needs an edit here.
 */
const BY_MODULE: Record<string, LucideIcon> = {
  jobs: ClipboardList,
  finance: Wallet,
  settlements: Receipt,
  organisation: Building2,
  'your company': Building2,
  configurations: Settings,
  'getting started': Compass,
  communications: MessagesSquare,
  customers: Users,
  contacts: Contact,
  chauffeurs: CarFront,
  channels: Radio,
  connect: Plug,
  website: Globe,
  reports: ChartColumn,
  dashboard: LayoutDashboard,
  'chatbot and ai': Bot,
  campaigns: Megaphone,
  'team access': ShieldCheck,
  calls: Phone,
  notifications: Bell,
  troubleshooting: LifeBuoy,
};

/** Falls back to a neutral chart glyph rather than nothing, so rows stay aligned. */
export const moduleIcon = (module: string | null | undefined): LucideIcon =>
  BY_MODULE[String(module || '').trim().toLowerCase()] ?? BarChart3;
